import { Icon as BlueIcon } from '@blueprintjs/core';
import { CircularProgress } from '@material-ui/core';
import { ITooltip } from '@components/Tooltip';
import {
  CircularLabelProgressWrapper,
  LabelsWrapper,
  Text,
} from './Labels.styles';

interface ILabels {
  type: 'error' | 'warning' | 'loading';
  text: string;
  loadingProgress?: number;
  disabled?: boolean;
  onClick?: (e: any) => void;
  size?: number;
  toolTipId?: string;
  toolTipContent?: any;
  isBorder?: boolean;
}

const Labels = ({
  type = 'loading',
  text = '',
  loadingProgress = 0,
  disabled = false,
  onClick,
  size = 12,
  toolTipId,
  toolTipContent,
  isBorder = true,
}: ILabels) => {
  return (
    <LabelsWrapper
      type={type}
      disabled={disabled}
      onClick={onClick}
      data-for={toolTipId}
      data-tip={toolTipContent}
      data-border={isBorder}
      data-type={type}
    >
      {type !== 'loading' ? (
        <BlueIcon
          size={size}
          color={type === 'error' ? '#D14343' : '#FFC979'}
          icon={type === 'error' ? 'error' : 'warning-sign'}
        />
      ) : (
        <CircularLabelProgressWrapper>
          <CircularProgress
            variant="determinate"
            value={100}
            thickness={8}
            size={14}
            className="overllProgress"
          />
          <CircularProgress
            variant="determinate"
            value={loadingProgress}
            thickness={8}
            size={14}
            className="completedProgress"
          />
        </CircularLabelProgressWrapper>
      )}

      <Text>{text}</Text>

      <ITooltip
        id={toolTipId}
        getContent={() => {
          return toolTipContent;
        }}
      />
    </LabelsWrapper>
  );
};

export default Labels;
